/**
 * Formats an API date string (e.g. 2026-01-27T16:49:29.422000+08:00) to date-only display (e.g. 27 Jan 2026).
 * Returns empty string for null/undefined/invalid input.
 */
export function formatDisplayDate(
  value: string | null | undefined
): string {
  if (value == null || value === "") return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
